import { useState } from "react";
import { Copy, Check, QrCode } from "lucide-react";
import { QRCodeSVG } from "qrcode.react";
import { toast } from "sonner";
import { useLanguage } from "@/context/LanguageContext";

export const ReferralShare = ({ link }) => {
  const { t } = useLanguage();
  const [copied, setCopied] = useState(false);
  const [showQr, setShowQr] = useState(false);
  const waHref = `https://wa.me/?text=${encodeURIComponent(`${t.credit.whatsappMessage} ${link}`)}`;

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(link);
    } catch {
      const el = document.createElement("textarea");
      el.value = link;
      document.body.appendChild(el);
      el.select();
      document.execCommand("copy");
      document.body.removeChild(el);
    }
    setCopied(true);
    toast.success(t.credit.copied);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <div className="space-y-3" data-testid="referral-share">
      <div className="flex items-center gap-2 bg-white border spec-border rounded-sm p-2">
        <input
          readOnly
          value={link}
          data-testid="referral-link-input"
          onFocus={(e) => e.target.select()}
          className="flex-1 min-w-0 bg-transparent text-xs font-mono-spec text-slate-700 px-2 py-1 outline-none truncate"
        />
        <button
          type="button"
          data-testid="referral-copy-btn"
          onClick={copy}
          className="shrink-0 inline-flex items-center gap-1.5 px-3 py-2 bg-slate-950 text-white text-xs font-mono-spec font-bold rounded-sm hover:bg-slate-800 transition-colors"
        >
          {copied ? <Check size={13} /> : <Copy size={13} />}
          {copied ? t.credit.copied : t.credit.copyLink}
        </button>
      </div>

      <a
        href={waHref}
        target="_blank"
        rel="noopener noreferrer"
        data-testid="referral-whatsapp-btn"
        className="flex items-center justify-center gap-2 w-full px-4 py-3 bg-[#1FA855] text-white text-sm font-semibold rounded-sm hover:brightness-105 transition-all shadow-sm"
      >
        {t.credit.shareWhatsapp}
      </a>

      <button
        type="button"
        data-testid="referral-qr-toggle"
        onClick={() => setShowQr((v) => !v)}
        className="flex items-center justify-center gap-2 w-full px-4 py-2.5 border spec-border bg-white text-slate-800 text-xs font-mono-spec font-semibold rounded-sm hover:bg-slate-50 transition-colors"
      >
        <QrCode size={14} />
        {showQr ? t.credit.hideQr : t.credit.showQr}
      </button>

      {showQr && (
        <div className="flex flex-col items-center gap-3 pt-1" data-testid="referral-qr">
          <div className="p-4 bg-white border spec-border rounded-lg shadow-sm">
            <QRCodeSVG
              value={link}
              size={172}
              level="M"
              bgColor="#ffffff"
              fgColor="#141210"
              includeMargin={false}
            />
          </div>
          <p className="text-[11px] font-mono-spec text-slate-500 text-center">{t.credit.qrHint}</p>
        </div>
      )}
    </div>
  );
};
